import { Routes } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { UserManageRequestFormComponent } from './component/users/user-manage-request-form/user-manage-request-form.component';
import { UserOtherManageRequestFormComponent } from './component/users/user-other-manage-request-form/user-other-manage-request-form.component';
import { UserFormAddItemComponent } from './component/users/user-form-add-item/user-form-add-item.component';
import { AddRequestComponent } from './component/users/user-add-request/add-request.component';
import { UserSelectEmailComponent } from './component/user-select-email/user-select-email.component';
import { UserSelectCaiComponent } from './component/user-select-cai/user-select-cai.component';
import { UserSelectQaComponent } from './component/users/user-select-qa/user-select-qa.component';
import { AdminManageRequestComponent } from './component/admin/admin-manage-request/admin-manage-request.component';
import { ManageUserComponent } from './component/admin/manage-user/manage-user.component';
import { CompanyCodeComponent } from './component/admin/Company/company-code.component';
import { PurchasingCodeComponent } from './component/admin/Purchasing/purchasing-code.component';
import { ReportSampleComponent } from './component/reports/report-sample/report-sample.component';
import { ReportCycleComponent } from './component/reports/report-cycle/report-cycle.component';
import { ReportItemDetailComponent } from './component/reports/report-item-detail/report-item-detail.component';
import { BuyerManageRequestFormComponent } from './component/Buyer/buyer-manage-request-form/buyer-manage-request-form.component';
import { BuyerOtherManageRequestFormComponent } from './component/Buyer/buyer-other-manage-request-form/buyer-other-manage-request-form.component';
import { DelegationComponent } from './component/delegation/delegation-list/delegation.component';
import { DelegationAddComponent } from './component/delegation/delegation-add/delegation-add.component';
import { AccessDenyUserComponent } from './component/invalid/access-deny-user/access-deny-user.component';
import { RouteProtectionGuard } from './core/guards/route-protection.guard';
import { LeadBuyerManageRequestFormComponent } from './component/Lead Buyer/lead-buyer-manage-request-form/lead-buyer-manage-request-form.component';
import { LeadBuyerOtherManageRequestFormComponent } from './component/Lead Buyer/lead-buyer-other-manage-request-form/lead-buyer-other-manage-request-form.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  //Users
  {
    path: 'user',
    children: [
      { path: 'request', component: UserManageRequestFormComponent },
      { path: 'other-request', component: UserOtherManageRequestFormComponent },
      { path: 'add-request', component: AddRequestComponent },
      { path: 'edit-request', component: AddRequestComponent },
      { path: 'view-request', component: AddRequestComponent },
      { path: 'view-other-request', component: AddRequestComponent },
      { path: 'view-item', component: UserFormAddItemComponent },
      { path: 'add-item', component: UserFormAddItemComponent },
      { path: 'edit-item', component: UserFormAddItemComponent },
    ],
  },
  //Lead Buyer
  {
    path: 'lead-buyer',
    canActivate: [RouteProtectionGuard],
    children: [
      {
        path: 'request',
        component: LeadBuyerManageRequestFormComponent,
      },
      {
        path: 'other-request',
        component: LeadBuyerOtherManageRequestFormComponent,
      },
      { path: 'edit-request', component: AddRequestComponent },
      { path: 'view-request', component: AddRequestComponent },
      { path: 'view-other-request', component: AddRequestComponent },
      { path: 'view-item', component: UserFormAddItemComponent },
    ],
  },
  //Buyer
  {
    path: 'buyer',
    canActivate: [RouteProtectionGuard],
    children: [
      {
        path: 'request',
        component: BuyerManageRequestFormComponent,
      },
      {
        path: 'other-request',
        component: BuyerOtherManageRequestFormComponent,
      },
      { path: 'edit-request', component: AddRequestComponent },
      { path: 'view-request', component: AddRequestComponent },
      { path: 'view-other-request', component: AddRequestComponent },
      { path: 'view-item', component: UserFormAddItemComponent },
    ],
  },

  // Delegation
  {
    path: 'delegation',
    children: [
      { path: 'delegation-list', component: DelegationComponent },
      { path: 'delegation-add', component: DelegationAddComponent },
    ],
  },

  //Reports
  {
    path: 'report',
    children: [
      { path: 'report-sample', component: ReportSampleComponent },
      { path: 'report-cycle', component: ReportCycleComponent },
      { path: 'report-item-detail', component: ReportItemDetailComponent },
    ],
  },

  //Admin
  {
    path: 'admin',
    canActivate: [RouteProtectionGuard],
    children: [
      {
        path: 'manage-user',
        component: ManageUserComponent,
      },
      {
        path: 'manage-request',
        component: AdminManageRequestComponent,
      },
      {
        path: 'company-code',
        component: CompanyCodeComponent,
      },
      {
        path: 'purchasing-code',
        component: PurchasingCodeComponent,
      },
      {
        path: 'edit-request',
        component: AddRequestComponent,
      },
      { path: 'view-item', component: UserFormAddItemComponent },
    ],
  },
  { path: 'user-select-email', component: UserSelectEmailComponent },
  { path: 'user-select-cai', component: UserSelectCaiComponent },
  { path: 'user-select-qa', component: UserSelectQaComponent },
  { path: 'access-deny-user', component: AccessDenyUserComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
